import { useCallback } from "react";
import { useSocket as useGlobalSocket } from "@context/SocketContext";

interface UseSocketOptions {
  autoConnect?: boolean; // Kept for backward compatibility but ignored
}

export const useSocket = (options: UseSocketOptions = {}) => {
  const { socket, isConnected } = useGlobalSocket();

  const emit = useCallback(<T = any>(event: string, data?: T) => {
    if (socket) {
      socket.emit(event, data);
    } else {
      console.warn(`Socket not connected, dropping emit: ${event}`);
    }
  }, [socket]);

  return {
    socket,
    isConnected,
    emit,
  };
};
